var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16331 53.8449C7.89037 55.572 10.6804 55.5735 12.409 53.8449L21.4368 44.8099L22.7331 46.1061C23.2636 46.695 24.2649 46.6954 24.7954 46.1061C25.3847 45.5464 25.3847 44.6035 24.7954 44.0438L15.9568 35.2051C15.3971 34.6159 14.4541 34.6159 13.8944 35.2051C13.3052 35.7648 13.3052 36.7078 13.8944 37.2675L15.1907 38.5637L6.16331 47.5988C4.42473 49.3074 4.42473 52.1359 6.16331 53.8449Z",
    fill: "#4FB5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9902 16.6442C31.7953 16.6442 27.7098 21.4088 25.9574 24.0009C27.3315 26.0107 31.4271 31.3753 35.9902 31.3753C40.1851 31.3753 44.2707 26.6107 46.0227 24.0182C44.649 22.0088 40.5534 16.6442 35.9902 16.6442ZM35.9902 28.4291C33.5535 28.4291 31.5709 26.4465 31.5709 24.0098C31.5709 21.573 33.5535 19.5904 35.9902 19.5904C38.427 19.5904 40.4096 21.573 40.4096 24.0098C40.4096 26.4465 38.427 28.4291 35.9902 28.4291Z",
    fill: "#2B71F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9902 22.5367C35.1773 22.5367 34.5171 23.1969 34.5171 24.0098C34.5171 24.8227 35.1773 25.4829 35.9902 25.4829C36.8031 25.4829 37.4633 24.8227 37.4633 24.0098C37.4633 23.1969 36.8031 22.5367 35.9902 22.5367Z",
    fill: "#2B71F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9902 4.85938C25.4311 4.85938 16.8398 13.4506 16.8398 24.0098C16.8398 34.569 25.4311 43.1602 35.9902 43.1602C46.5494 43.1602 55.1406 34.569 55.1406 24.0098C55.1406 13.4506 46.5494 4.85938 35.9902 4.85938ZM49.0395 24.7651C48.8067 25.1549 43.2507 34.3215 35.9902 34.3215C28.7298 34.3215 23.1738 25.1549 22.941 24.7651C22.6632 24.3002 22.6632 23.719 22.941 23.2544C23.1738 22.8647 28.7298 13.698 35.9902 13.698C43.2507 13.698 48.8067 22.8647 49.0395 23.2544C49.3173 23.719 49.3173 24.3002 49.0395 24.7651Z",
    fill: "#2B71F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.ca8677f6ad0e7287dea2c43a0a3b9144.svg";
export { ForwardRef as ReactComponent };